export default __webpack_public_path__ + "static/The Right Time To Find A New Mattress-3b0f1bf344563c5f8196062cebe70214.jpg";